import styled, { FlattenSimpleInterpolation, StyledComponent, css } from 'styled-components'

export const StyledTable = css`
  position: relative;
  .p-datatable-tbody > tr > td {
    border: 1px solid var(--indigo-4);
    border-width: 0 0 1px 0;
  }
  .p-editable-column.p-cell-editing {
    .p-inputtext {
      font-size: 13px;
      width: 100%;
      &:enabled:focus {
        border: 1px solid var(--primary-50);
        box-shadow: 0 0 0 3px var(--primary-30);
      }
    }
  }
  .p-row-toggler {
    &:focus {
      box-shadow: none !important;
    }
  }
  .sticky-col,
  .sticky-col-end {
    position: sticky;
    position: -webkit-sticky;
    background-color: var(--white-100);
    z-index: 1;
  }
  .sticky-col {
    &:first-of-type {
      left: 0;
    }
  }
  .sticky-col-end {
    &:last-of-type {
      right: 0;
    }
  }
`

export const WrapperTable = styled.div<{
  customStyles?: StyledComponent<any, any> | FlattenSimpleInterpolation
}>`
  ${StyledTable}
  ${(props) => {
    return props.customStyles ? props.customStyles : null
  }}
`
